import type {
  MfaAuditAction,
  MfaVerificationMethod,
} from '../types/mfaAdmin.types';

// UI copy for the enum values shared between the AdminResetModal picker
// (source of truth for what a value MEANS to the admin) and the AuditLog
// row where the same value is displayed back after a reset. Hoisted so
// the two views don't drift — if we ever add a fifth verification method,
// only this file changes and both surfaces pick it up.

export const METHOD_LABELS: Record<MfaVerificationMethod, string> = {
  in_person_or_video: 'In persoon of via videobellen',
  phone_callback: 'Telefonisch (uitgaande call naar bekend nummer)',
  knowledge_check: 'Kennisvraag beantwoord',
  other: 'Anders (toelichten in notities)',
};

export const ACTION_LABELS: Record<MfaAuditAction, string> = {
  self_activation: 'Zelf geactiveerd',
  admin_reset: 'Admin reset',
  admin_email_code_issued: 'Admin email-code',
  admin_cohort_warning_sent: 'Cohort waarschuwing',
};

// Chip color hint for the audit-row action chip. Keeps the visual
// vocabulary consistent — warning for admin-actions-on-users, success
// for self-driven, neutral for passive bookkeeping.
export const ACTION_COLORS: Record<
  MfaAuditAction,
  'success' | 'warning' | 'primary' | 'neutral'
> = {
  self_activation: 'success',
  admin_reset: 'warning',
  admin_email_code_issued: 'primary',
  admin_cohort_warning_sent: 'neutral',
};
